import { withStyles } from '@material-ui/core/styles';
import styles from './Notification.styles';
import Notification from './Notification';

export default withStyles(styles)(Notification);
